import {takeEvery} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeEvery(ACTION.RECEIVE_COMPLAINT.REQUEST, saga.receiveComplaint);
    yield takeEvery(ACTION.RECEIVE_COMPLAINT.SUCCESS, saga.onReceiveComplaintSuccess);
    yield takeEvery(ACTION.RECEIVE_COMPLAINT.FAILED, saga.onReceiveComplaintFailed);
}